import { Divider } from '@mui/material';

export const ProposalCurationVerticalDivider = ({ color }) => (
  <Divider
    orientation="vertical"
    flexItem
    sx={{
      borderColor: color,
      borderRightWidth: '1px',
      opacity: 1,
      marginX: '8px',
    }}
  />
);
